import { useaxios } from "../../../utils/useaxios";
export default (customer_id) => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    return useaxios('customer/sell_invoice_ledger.php', { customer_id }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            return false;
        }
        if (res.status == "ok") {
            return res?.data;
        }
    });
}